var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Box = function Box(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.51 2.128a1 1 0 0 1 .98 0l7.985 4.492a.995.995 0 0 1 .525.9v8.98a1 1 0 0 1-.51.872l-7.983 4.49A.995.995 0 0 1 12 22h-.01a.995.995 0 0 1-.495-.136L3.51 17.372A1 1 0 0 1 3 16.5V7.515a.994.994 0 0 1 .522-.894l7.988-4.493ZM5 9.21v6.705l6 3.375v-6.705l-2.25-1.266V13a.75.75 0 0 1-1.5 0v-2.524L5 9.21Zm3.033-.589L6.04 7.5 12 4.147l1.993 1.121-5.96 3.353Zm1.53.86L12 10.854 17.96 7.5l-2.437-1.371-5.96 3.353ZM19 15.916l-6 3.375v-6.705l6-3.375v6.705Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Box;